import { defaultMeta } from '@/constants/defaultMeta';
import { parseDateRangeSearch } from '@/lib/parseDateRange';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { affiliatesListQueries } from '@/services/affiliate/affiliate.queries';
import { useSearch } from '@tanstack/react-router';

export const useAffiliateList = () => {
  const search = useSearch({ from: '/(app)/users/affiliates/' });
  const { createdDate, page, fetch, sort } = search;
  const parsedCreatedDate = parseDateRangeSearch(createdDate, { start: 0, end: 0 });
  const { data, isFetched, isLoading } = useQuery({
    ...affiliatesListQueries.list({
      fromDate: parsedCreatedDate?.start ?? 0,
      toDate: parsedCreatedDate?.end ?? 0,
      row: page,
      fetch: fetch,
      search: search.q ?? '',
    }),
    select: (res) => ({
      ...res,
      data: sortBy(res.data, sort),
    }),
  });

  return {
    affiliates: data?.data || [],
    isFetched,
    isLoading,
    pagination: data?.meta?.pagination || defaultMeta,
  };
};
